import React from 'react';
import ReddyLayout from '../components/home/ReddyLayout';
import GameThumbGrid from '../components/home/GameThumbGrid';
import SportSection from '../components/home/SportSection';
import { SPORT_SECTIONS } from '../data/homeData';

/* In-Play — live matches across all sports. Mirrors the homepage exactly: same
   ReddyLayout chrome (commentary marquee + SportsNav come from the Header, sidebar,
   HomeFooter, mobile bottom-nav), the same mobile custom-thumb-section / NEW LAUNCH
   strip (GameThumbGrid), and the same .home-page scoped mobile rules — but each
   sport's rows are filtered to live matches only. Static for now; wiring a real
   live-odds feed (e.g. /api/odds?live=1) is a separate later phase. */
export default function InPlayPage() {
  const liveSections = SPORT_SECTIONS
    .map((s) => ({ ...s, rows: s.rows.filter((r) => r.live) }))
    .filter((s) => s.rows.length > 0);

  return (
    <ReddyLayout>
      <div className="home-page">
        {/* same mobile thumb-grid + NEW LAUNCH strip the homepage shows on top */}
        <GameThumbGrid />
        {liveSections.length > 0 ? (
          liveSections.map((section) => <SportSection key={section.key} section={section} />)
        ) : (
          <div className="text-center p-4" style={{ color: '#888' }}>
            No live matches at the moment
          </div>
        )}
      </div>
    </ReddyLayout>
  );
}
